module.exports = __webpack_public_path__ + "img/torii-gate.1172d812.svg";